<template>
  <modal :modal-key="'daily_bonus_points_reward'"
         :class-style="'modal--welcomeback no_space'" :body-style="'achievement'"
         @close="$emit('close')">
    <template slot="header">
      <h1>{{ getTranslations.home_bonus_header }}</h1>
      <h1>{{ getTranslations.home_bonus_you_won }} {{ bonusDailyModal.quantity }} {{ getTranslations.home_bonus_points }}</h1>
    </template>
    <template slot="body">
      <div class="daily_bonus_selected prize">
        <div class="bounce_box bounce_animation">
          <img class="icon" src="static/images/trophy_mod.svg" alt="">
        </div>
        <a @click.prevent="closeModal" style="cursor:pointer" class="btn2 btn2_modal btn2--std btn2--small">
          {{ getTranslations.home_bonus_button_procced }}</a>
      </div>
    </template>
  </modal>
</template>

<script>
// modal_daily_bonus_calendar_step_2_points.html
import { mapGetters, mapMutations, mapState } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';

export default {
  name: 'daily-bonus-points-reward',
  data() {
    return {
      timer: 0,
      counter: 0,
    };
  },
  components: {
    Modal,
  },
  beforeDestroy() {
    this.closeModal();
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'clearBonusDailyModal',
    ]),
    closeModal() {
      this.storeModalForHomePage(null);
      this.clearBonusDailyModal();
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'bonusDailyModal',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/daily_bonus_modals/PointsBonus.vue